import ImagenJpg from '../../assets/img/imagen.jpg';

const HomePage = () => {
    return (
        <>
            <section className='wrapper-content'>
                <div className='page-wrapper'>
                    <div className='container-fluid pe-0'>
                        <div className='row pt-3'>
                            <div className='col-lg-6 text-justify'>
                                <h4 className='txt-blue-dark'>
                                    Consectetur adipiscing elit
                                </h4>
                                <p>
                                    <br />
                                    Consectetur adipiscing elit, sed do eiusmod
                                    tempor incididunt ut labore et dolore magna
                                    aliqua. Quis ipsum suspendisse ultrices
                                    gravida. Risus commodo viverra maecenas
                                    accumsan lacus vel facilisis. orem ipsum
                                    dolor sit amet, consectetur adipiscing elit,
                                    sed do eiusmod tempor incididunt ut labore
                                    et dolore magna aliqua. Quis ipsum
                                    suspendisse ultrices gravida. Risus commodo
                                    viverra maecenas accumsan lacus vel
                                    facilisis.
                                    <br />
                                    Consectetur adipiscing elit, sed do eiusmod
                                    tempor incididunt ut labore et dolore magna
                                    aliqua. Quis ipsum suspendisse ultrices
                                    gravida. Risus commodo viverra maecenas
                                    accumsan lacus vel facilisis. orem ipsum
                                    dolor sit amet, consectetur adipiscing elit,
                                    sed do eiusmod tempor incididunt ut labore
                                    et dolore magna aliqua. Quis ipsum
                                    suspendisse ultrices gravida. Risus commodo
                                    viverra maecenas accumsan lacus vel
                                    facilisis.
                                </p>
                            </div>

                            <div className='col-lg-6 pe-0'>
                                <img
                                    className='img-fluid'
                                    src={ImagenJpg}
                                    alt=''
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HomePage;
